import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="container">
          <div className="footer-grid">

            {/* Brand */}
            <div className="footer-section footer-section--brand">
              <div className="footer-brand-name">ABC Básculas</div>
              <p>
                Automatización Básculas y Control, S.A. de C.V. Soluciones integrales
                en pesaje industrial desde 1994.
              </p>
              <div className="footer-contact-block">
                <a href="tel:+523336349050" className="footer-contact-link">(33) 3634-9050</a>
                <a href="mailto:abc@abcscale.mx" className="footer-contact-link">abc@abcscale.mx</a>
              </div>
            </div>

            {/* Navigation */}
            <div className="footer-section">
              <h4>Navegación</h4>
              <ul className="footer-links">
                <li><Link to="/">Inicio</Link></li>
                <li><Link to="/quienes-somos">Quiénes Somos</Link></li>
                <li><Link to="/servicios">Servicios</Link></li>
                <li><Link to="/automatizacion">Automatización</Link></li>
                <li><Link to="/software">Software</Link></li>
                <li><Link to="/clientes">Clientes</Link></li>
                <li><Link to="/contacto">Contacto</Link></li>
              </ul>
            </div>

            {/* Products */}
            <div className="footer-section">
              <h4>Productos</h4>
              <ul className="footer-links">
                <li><Link to="/productos/basculas-camioneras">Básculas Camioneras</Link></li>
                <li><Link to="/productos/basculas-de-piso">Básculas de Piso</Link></li>
                <li><Link to="/productos/basculas-de-banco">Básculas de Banco</Link></li>
                <li><Link to="/productos/celdas-de-carga">Celdas de Carga</Link></li>
                <li><Link to="/productos/indicadores-de-peso">Indicadores de Peso</Link></li>
                <li><Link to="/productos/basculas-verificadoras">Básculas Verificadoras</Link></li>
                <li><Link to="/productos/dinamometros">Dinamómetros</Link></li>
                <li><Link to="/productos" className="footer-link-all">Ver todos los productos →</Link></li>
              </ul>
            </div>

            {/* Contact */}
            <div className="footer-section">
              <h4>Contacto</h4>
              <address className="footer-address">
                <p>Av. Tabachines 3750</p>
                <p>Col. Loma Bonita Ejidal</p>
                <p>Zapopan, Jalisco, C.P. 45085</p>
              </address>
              <div className="footer-hours">
                <p className="footer-hours-label">Horario de atención</p>
                <p>Lun – Vie: 9:00 – 18:00</p>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <p>&copy; 2026 Automatización Básculas y Control, S.A. de C.V. Todos los derechos reservados.</p>
            <div className="footer-bottom-links">
              <Link to="/clientes">Área de Clientes</Link>
              <Link to="/contacto">Contacto</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
